import { gql, useQuery } from "@apollo/client";
import { AtlasSelectContentItem, Select } from "@resource/atlas";
import { FetchDepartments } from "generated/schemaTypes";
import { sortBy } from "lodash";
import { useMemo } from "react";

const FETCH_DEPARTMENTS = gql`
  query FetchDepartmentsForDepartmentSelect {
    atsDepartments {
      id
      name
    }
  }
`;

interface DepartmentSelectProps {
  selectedKey: string | null;
  setValue(newDepartmentId: string | null): void;
}

function DepartmentSelect({ selectedKey, setValue }: DepartmentSelectProps) {
  const { data, loading } = useQuery<FetchDepartments>(FETCH_DEPARTMENTS);
  const departments = useMemo(
    () => (data?.atsDepartments?.length ? data.atsDepartments : []),
    [data]
  );
  const NO_DEPARTMENT = "";

  const items = useMemo(
    (): AtlasSelectContentItem[] => [
      {
        _type: "option",
        value: NO_DEPARTMENT,
        children: "No department",
      },
      ...sortBy(departments, ({ name }) => name.toLowerCase()).map(
        (department): AtlasSelectContentItem =>
          ({
            _type: "option",
            value: department.id,
            children: department.name,
          } as const)
      ),
    ],
    [departments]
  );

  return (
    <Select.Root
      searchable
      setValue={(value) => {
        if (typeof value === "string") setValue(value);
      }}
      value={selectedKey ?? NO_DEPARTMENT}
    >
      <Select.Trigger className="w-full bg-light-gray-500" />
      <Select.Content
        isLoading={loading}
        items={items}
        UNSAFE_disableDynamicCollectionWarnings
      />
    </Select.Root>
  );
}

export default DepartmentSelect;
